import axios from 'axios'
import qs from 'querystring'

export default {
  async autocomplete (value) {
    const query = { input: value }
    const qstring = qs.stringify(query)
    return axios.get(`/api/locations/autocomplete?${qstring}`)
      .then(r => r.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/locations.js